import { render, staticRenderFns } from "./RealEstateList.vue?vue&type=template&id=05b176ba&"
import script from "./RealEstateList.vue?vue&type=script&lang=js&"
export * from "./RealEstateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports